import { Stack } from '@/react/common/stacks/types';

import { useGitHelmChartInfo } from '../helmChartSourceQueries/useGitHelmChartInfo';

export function useGitChartInfoFromStack(stack?: Stack) {
  const credentialID = stack?.GitConfig?.Authentication?.GitCredentialID;
  return useGitHelmChartInfo(
    {
      repository: stack?.GitConfig?.URL || '',
      chartPath: stack?.HelmChartPath || '',
      reference: stack?.GitConfig?.ReferenceName,
      username: stack?.GitConfig?.Authentication?.Username,
      password: stack?.GitConfig?.Authentication?.Password,
      authorizationType: stack?.GitConfig?.Authentication?.AuthorizationType,
      gitCredentialID: credentialID,
      tlsSkipVerify: stack?.GitConfig?.TLSSkipVerify,
      command: 'chart',
    },
    { enabled: !!stack }
  );
}
